"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yAxisTitleStyle = exports.yAxisLabelStyle = exports.xAxisTitleStyle = exports.xAxisLabelStyle = exports.rightLineLegendColumn = exports.deepMerge = exports.bottomLegendRow = exports.activeLabelStyle = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _color = require("../../styles/variables/_color");
var _typography = require("./typography");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const deepMerge = function (obj1, obj2) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return (0, _merge.default)({}, obj1, obj2, ...args);
}; // {} is used here to ensure obj1 is not modified
exports.deepMerge = deepMerge;
const rightLineLegendColumn = exports.rightLineLegendColumn = {
  layout: 'vertical',
  align: 'right',
  verticalAlign: 'middle',
  itemMarginBottom: 12,
  symbolPadding: 4,
  symbolWidth: 16,
  width: '40%'
};
const bottomLegendRow = exports.bottomLegendRow = {
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom',
  itemDistance: 20,
  symbolPadding: 4,
  symbolWidth: 16
};
const yAxisTitleStyle = exports.yAxisTitleStyle = {
  ..._typography.bodySmall,
  color: _color.colorTextSecondary
};
const xAxisTitleStyle = exports.xAxisTitleStyle = {
  ..._typography.bodySmall,
  color: _color.colorTextSecondary
};
const yAxisLabelStyle = exports.yAxisLabelStyle = {
  ..._typography.formLabelSmall
};
const xAxisLabelStyle = exports.xAxisLabelStyle = {
  ..._typography.buttonTextExtraSmall
};
const activeLabelStyle = exports.activeLabelStyle = {
  ..._typography.buttonTextExtraSmall,
  ..._typography.underline,
  color: _color.colorTextPrimary,
  fill: _color.colorTextPrimary
};